/**
 *
 * Version
 *
 */

import React from 'react';
import styled from 'styled-components';
import { version } from '../../../package.json';

const Wrapper = styled.div`
  display: flex;
  height: 100vh;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

const Line = styled.span`
  text-align: center;
  margin: ${props => props.margin || 'initial'};
`;

const Pre = styled.pre`
  font-size: 0.8em;
  margin: 0;
`;

const Link = styled.a`
  text-decoration: none;
`;

/* eslint-disable */
function Version() {
  const lastCommit = '327c615 (grafted, HEAD, tag: v1.70.19) Thu Aug 27 20:04:05 2026 +0200';
  const releaseNotes = '';
  return (
    <Wrapper>
      <Line><Link href="/">
        <pre>{`
                 _   _  ___ _ __ ___    __ _  __ _  ___ _ __   ___ _   _                   
                | | | |/ __| '_ \` _ \\  / _\` |/ _\` |/ _ \\ '_ \\ / __| | | |                  
                | |_| | (__| | | | | || (_| | (_| |  __/ | | | (__| |_| |                  
                 \\__,_|\\___|_| |_| |_(_)__,_|\\__, |\\___|_| |_|\\___|\\__, |                  
                                              __/ |                 __/ |                  
 ____             _          __  __ _         |___/___  _       _   |___/                   
|  _ \\           | |        / _|/ _(_)          |  __ \\| |     | |  / _|                    
| |_) | __ _  ___| | _____ | |_| |_ _  ___ ___  | |__) | | __ _| |_| |_ ___  _ __ _ __ ___  
|  _ < / _\` |/ __| |/ / _ \\|  _|  _| |/ __/ _ \\ |  ___/| |/ _\` | __|  _/ _ \\| '__| '_ \` _ \\ 
| |_) | (_| | (__|   < (_) | | | | | | (_|  __/ | |    | | (_| | |_| || (_) | |  | | | | | |
|____/ \\__,_|\\___|_|\\_\\___/|_| |_| |_|\\___\\___| |_|    |_|\\__,_|\\__|_| \\___/|_|  |_| |_| |_|
`}</pre></Link>
      </Line>
      {lastCommit && <Line>{lastCommit}</Line>}
      <Line>{`Version: ${version} (${process.env.SERVER_ENV})`}</Line>
      <Line margin="24px 0">------- <Link target="_blank" href="/release_notes">Release Notes</Link> -------</Line>
      {releaseNotes && <Pre>{releaseNotes}</Pre>}
    </Wrapper>
  );
}
/* eslint-enable */

export default Version;
